$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  let posType = $('#classic-location-products').data('pos-type');
  if (p === 'events' && posType === 'scroll') {
    $(document).on('submit', '.product-search-form', function (e) {
      e.preventDefault();
      let formData = new FormData($(this)[0]);
      formData.append('pos_type', posType);
      $.ajax({
        type: 'POST',
        url: '/ajax/events/get_all_products',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data) {
            if (data.search) {
              $('.product-group').hide();
            } else {
              $('.product-group').show();
            }
            $('#product-group-').html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on('click', '.category-nav-link', function (e) {
      const locationId = parseInt($('#location-products').data('location-id'));
      const formData = new FormData();
      $('#search_string').val('');
      formData.append('search_string', '');
      formData.append('event_id', locationId);
      const postype = localStorage.getItem('postype') ?? null;
      formData.append('pos_type', postype);
      $.ajax({
        type: 'POST',
        url: '/ajax/events/get_all_products',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data) {
            if (data.search) {
              $('.product-group').hide();
            } else {
              $('.product-group').show();
            }
            $('#product-group-').html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
  }

  if (p === 'events' && posType === 'classic') {
    $(document).on('click', '.pagination a', function (e) {
      e.preventDefault();
      // let page = parseInt($(this).attr("href").substring(6));
      // let page = parseInt($(this).attr("href").match(/page=(\d+)/)[1]);
      let href = $(this).attr('href');
      let urlParams = new URLSearchParams(href.substring(1));
      let page = parseInt(urlParams.get('page'));
      const activeCategoryTab = $('.tablinks.active');
      const categoryId = activeCategoryTab.length
        ? activeCategoryTab.data('category-id')
        : null;

      loadClassicCategoryProducts(categoryId, page);
    });

    // Sort menu: standard, price low-high, price high-low, most sold, alphabetical
    $(document).on('click', '.pos-product-sort-option', function (e) {
      e.preventDefault();
      // Search results are not sorted, they keep the search order
      if ($('#search_string').val()) {
        return;
      }
      const activeCategoryTab = $('.tablinks.active');
      if (!activeCategoryTab.length) {
        return;
      }

      const sort = $(this).attr('data-sort') || '';
      if (sort === ($('#pos-product-sort-button').attr('data-sort') || '')) {
        return;
      }
      const categoryId = activeCategoryTab.data('category-id');
      setPosProductSort(sort, categoryId);

      loadClassicCategoryProducts(categoryId, 1);
    });

    // Search results and the POS's own reloads replace the panes: count again
    $(document).ajaxComplete(function () {
      updatePosProductCount();
    });
    updatePosProductCount();

    // A new search re-renders the product list in normal order
    $(document).on('submit', '.product-search-form', function () {
      setPosProductSort('');
    });
    $(document).on('click', '#clear-search-product-button', function () {
      setPosProductSort('');
    });
  }
});

function setPosProductSort(sort, categoryId = '') {
  const sortButton = $('#pos-product-sort-button');
  if (!sortButton.length) {
    return;
  }
  sortButton.attr('data-sort', sort);
  // Remember which product group is sorted so it can be restored later
  sortButton.attr('data-sorted-category-id', sort ? categoryId : '');
  sortButton.toggleClass('active', sort !== '');
  sortButton
    .find('.pos-product-sort-label')
    .text(sortButton.attr('data-label-' + (sort || 'default')));
  $('.pos-product-sort-option').each(function () {
    $(this).toggleClass('active', ($(this).attr('data-sort') || '') === sort);
  });
  // The dual screen master sends the new order to its slave
  $(document).trigger('pos-product-sort-change');
}

// The sort chosen for a product group ('' = its normal order); only the sorted group has one
function getPosProductSort(categoryId) {
  const sortButton = $('#pos-product-sort-button');
  if (
    !sortButton.length ||
    String(sortButton.attr('data-sorted-category-id')) !== String(categoryId)
  ) {
    return '';
  }
  return sortButton.attr('data-sort') || '';
}

// "Viser N varer" above the grid, for the active product group
function updatePosProductCount() {
  const $count = $('#pos-product-count');
  if (!$count.length) {
    return;
  }
  const $tab = $('.tablinks.active').first();
  const $pane = $tab.length
    ? $('#category-tabcontent-' + $tab.attr('data-category-id'))
    : $();
  if (!$pane.length) {
    $count.empty();
    return;
  }

  const total = parseInt($pane.attr('data-total-products'), 10) || 0;
  // {count} placeholder, with or without the server filling it in
  $count.text(
    ($count.attr('data-template') || '').replace(/\{\{?count\}?\}/, total)
  );

  // Search results keep the search order
  $('#pos-product-sort-button').prop(
    'disabled',
    $.trim($('#search_string').val() || '') !== ''
  );
}

function loadClassicCategoryProducts(categoryId, page) {
  // The dual screen master keeps a whole group in one grid and loads it itself
  if (
    typeof dualScreenLoadCategoryProducts === 'function' &&
    dualScreenLoadCategoryProducts(categoryId)
  ) {
    return;
  }

  const formData = new FormData();
  formData.append('page', page);
  formData.append('search_string', $('#search_string').val());
  formData.append('category_id', categoryId);
  formData.append('location_id', $('#location-id').val());
  formData.append(
    'pos_sort',
    $('#pos-product-sort-button').attr('data-sort') || ''
  );

  $.ajax({
    type: 'POST',
    url: '/api/v1/private/products/get-category-products',
    data: formData,
    enctype: 'multipart/form-data',
    async: true,
    cache: false,
    processData: false,
    contentType: false,
  })
    .done(function (data) {
      if (
        data.products_html &&
        data.products_html !== undefined &&
        data.products_html !== null
      ) {
        $('.tabcontent #category-' + categoryId).html(data.products_html);
      }
      if (data.total_products !== undefined) {
        $('#category-tabcontent-' + categoryId).attr(
          'data-total-products',
          data.total_products
        );
      }
      // Always replace so a stale page selection does not survive a re-sort
      $('.tabcontent #pagenation-container-' + categoryId).html(
        data.pagination || ''
      );
    })
    .fail(function (data) {
      if (
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
        return;
      }

      if (data.responseJSON.error) {
        showToast({
          type: 'error',
          title: 'Error',
          message: data.responseJSON.error,
          position: 'top-right',
          duration: 4000,
        });
      }
    });
}

function selectCategory(evt, categoryId) {
  // Clicking a product group (also the active one) brings back its normal order
  const sortButton = $('#pos-product-sort-button');
  if (sortButton.length && sortButton.attr('data-sort')) {
    const sortedCategoryId = sortButton.attr('data-sorted-category-id');
    setPosProductSort('');
    if ($('#search_string').val() === '') {
      loadClassicCategoryProducts(sortedCategoryId, 1);
    }
  }

  $('.tabcontent').hide();
  $('.tablinks').removeClass('active');
  $('#category-tabcontent-' + categoryId).css('display', 'block');
  $(evt.currentTarget).addClass('active');
  updatePosProductCount();

  if (categoryId !== 'all' && $('#search_string').val() !== '') {
    const container = $('#pagenation-container-' + categoryId);
    // Disable all <a> inside this container
    container.find('a').each(function () {
      $(this).css({
        'pointer-events': 'none',
        color: '#999', // optional: gray it out
        'text-decoration': 'none', // optional: remove underline
      });
    });

    // Optional: Change cursor globally
    container.css('cursor', 'not-allowed');
  }
}
